module.exports = __webpack_public_path__ + "img/piggy-logo.fa9544a1.png";